import { z } from 'zod';

export const SalesRankingLastUpdatedAtDTOSchema = z
  .object({
    lastUpdatedAt: z.string().describe('판매 상품 랭킹 데이터 최종 갱신 시각'),
  })
  .describe('SalesRankingLastUpdatedAtDTO');

export type SalesRankingLastUpdatedAtDTO = z.infer<typeof SalesRankingLastUpdatedAtDTOSchema>;
